import { CdkTableModule } from '@angular/cdk/table';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { DraftDepotRequeteService } from '../depot-requete/draft-depot-requete.service';
import { RenameDossierComponent } from '../requete/rename-dossier/rename-dossier.component';
import { TelerecourspnrSharedModule } from '../shared';
import { HomeComponent } from './home.component';
import { DEFAULT_ROUTE, HOME_ROUTE } from './home.route';
import { AutofocusDirective } from './mes-dossiers/auto-focus.directive';
import { DossierModalComponent } from './mes-dossiers/dossier-modal-component';
import { FilterBlockComponent } from './mes-dossiers/filter-block/filter-block.component';
import { MesDossiersComponent } from './mes-dossiers/mes-dossiers.component';
import { MobileSortBlockComponent } from './mes-dossiers/mobile-sort-block/mobile-sort-block.component';
import { NumeroDossierComponent } from './mes-dossiers/numero-dossier/numero-dossier.component';
import { SortStatusComponent } from './mes-dossiers/sort-status/sort-status.component';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
/* import { TooltipsComponent } from '../requete/historique-requete/timeline/tooltips/tooltips.component'; */

@NgModule({
    imports: [
        TelerecourspnrSharedModule,
        RouterModule.forRoot([HOME_ROUTE, DEFAULT_ROUTE], { useHash: true }),
        CdkTableModule,
        NgbTooltipModule
    ],
    declarations: [
        HomeComponent,
        MesDossiersComponent,
        NumeroDossierComponent,
        DossierModalComponent,
        FilterBlockComponent,
        MobileSortBlockComponent,
        AutofocusDirective,
        SortStatusComponent,
        RenameDossierComponent,
/*         TooltipsComponent */
    ],
    entryComponents: [DossierModalComponent, RenameDossierComponent],
    providers: [DraftDepotRequeteService],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class TelerecourspnrHomeModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/home/home.module.ts